"use client";

export const SPECIALTY_DIRECTORY_BOOKING_ATTRIBUTION_STORAGE_KEY =
  "specialty_directory_booking_attribution";
export const SPECIALTY_DIRECTORY_BOOKING_ATTRIBUTION_TTL_MS = 30 * 60 * 1000;

export type SpecialtyDirectoryBookingAttribution = {
  specialtySlug: string;
  therapistId: string;
  createdAt: number;
};

export function storeSpecialtyDirectoryBookingAttribution(
  attribution: SpecialtyDirectoryBookingAttribution,
): void {
  if (typeof window === "undefined") return;

  window.sessionStorage.setItem(
    SPECIALTY_DIRECTORY_BOOKING_ATTRIBUTION_STORAGE_KEY,
    JSON.stringify(attribution),
  );
}

export function consumeSpecialtyDirectoryBookingAttribution({
  therapistId,
  now = Date.now(),
}: {
  therapistId: string;
  now?: number;
}): SpecialtyDirectoryBookingAttribution | null {
  if (typeof window === "undefined") return null;

  const stored = window.sessionStorage.getItem(
    SPECIALTY_DIRECTORY_BOOKING_ATTRIBUTION_STORAGE_KEY,
  );
  window.sessionStorage.removeItem(
    SPECIALTY_DIRECTORY_BOOKING_ATTRIBUTION_STORAGE_KEY,
  );

  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored) as {
      specialtySlug?: unknown;
      therapistId?: unknown;
      createdAt?: unknown;
    };
    if (
      typeof parsed.specialtySlug !== "string" ||
      !parsed.specialtySlug ||
      typeof parsed.therapistId !== "string" ||
      !parsed.therapistId ||
      typeof parsed.createdAt !== "number" ||
      !Number.isFinite(parsed.createdAt) ||
      now - parsed.createdAt > SPECIALTY_DIRECTORY_BOOKING_ATTRIBUTION_TTL_MS ||
      parsed.createdAt > now ||
      parsed.therapistId !== therapistId
    ) {
      return null;
    }

    return {
      specialtySlug: parsed.specialtySlug,
      therapistId: parsed.therapistId,
      createdAt: parsed.createdAt,
    };
  } catch {
    return null;
  }
}
